import React, { useEffect } from 'react';
// Previous imports (commented out - no longer needed but kept for reference):
// import { useState, useRef } from 'react';
// import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
// import DialogPopup from 'common/DialogPopUp';
import './CookieConsent.css';

// Utility function to check if cookie consent is given
export const hasCookieConsent = () => {
  const cookieConsent = Cookies.get('cookieConsent');
  return cookieConsent === 'accepted';
};

// Global function to trigger login blocked modal
// let showLoginBlockedModalRef = null;

const CookieConsent = () => {
  // const [showBanner, setShowBanner] = useState(false);
  // const [showLoginBlocked, setShowLoginBlocked] = useState(false);
  // const location = useLocation();
  // const isLoginPage = location.pathname === '/account/login';
  // const setShowLoginBlockedRef = useRef(null);

  // useEffect(() => {
  //   // Store the setter function in ref
  //   setShowLoginBlockedRef.current = setShowLoginBlocked;
  //   // Expose function to show login blocked modal globally
  //   showLoginBlockedModalRef = () => {
  //     if (setShowLoginBlockedRef.current) {
  //       setShowLoginBlockedRef.current(true);
  //     }
  //   };

  //   // Check if user has already made a choice using cookies
  //   // Only show banner on login page
  //   const cookieConsent = Cookies.get('cookieConsent');
  //   if (!cookieConsent && isLoginPage) {
  //     setShowBanner(true);
  //   }
  // }, [isLoginPage]);

  useEffect(() => {
    // If consent already given, ensure Clarity loads (idempotent)
    const consentGiven = Cookies.get('cookieConsent') === 'accepted';
    if (consentGiven && typeof window !== 'undefined' && typeof window.loadClarity === 'function') {
      window.loadClarity();
    }
  }, []);

  // const handleAccept = () => {
  //   // Set cookie with 1 year expiration
  //   Cookies.set('cookieConsent', 'accepted', { expires: 365 });
  //   setShowBanner(false);
  //   setShowLoginBlocked(false);
  //   if (typeof window !== 'undefined' && typeof window.loadClarity === 'function') {
  //     window.loadClarity();
  //   }
  // };

  // const handleReject = () => {
  //   // Record rejection with 1 year expiration
  //   Cookies.set('cookieConsent', 'rejected', { expires: 30 });
  //   setShowBanner(false);
  //   setShowLoginBlocked(false);
  // };

  // const handleCookiePolicy = () => {
  //   // Redirect to cookie policy page
  //   window.location.href = '/cookie-policy.html';
  // };

  // const handleCloseLoginBlocked = () => {
  //   setShowLoginBlocked(false);
  // };

  // const handleAcceptFromModal = () => {
  //   handleAccept();
  // };

  // Cookie consent is now handled through the Terms and Conditions checkbox
  // on login and signup pages, so this component no longer needs to show a banner
  return null;

  // Previous implementation with banner and modal (commented out):
  // return (
  //   <>
  //     {showBanner && (
  //       <div className="cookie-consent-banner">
  //         <div className="cookie-consent-content">
  //           <p>By continuing to use this website, you consent to our use of cookies.</p>
  //           <div className="cookie-consent-buttons">
  //             <button onClick={handleCookiePolicy} className="cookie-consent-info">
  //               What for?
  //             </button>
  //             <button onClick={handleAccept} className="cookie-consent-accept">
  //               Yes, I understand
  //             </button>
  //             {/* <button onClick={handleReject} className="cookie-consent-reject">
  //               Reject Cookies
  //             </button> */}
  //           </div>
  //         </div>
  //       </div>
  //     )}

  //     <DialogPopup
  //       isOpen={showLoginBlocked}
  //       setIsOpen={setShowLoginBlocked}
  //       heading="Cookie Consent Required"
  //       message="You must accept our cookie policy before you can login. This is required to ensure proper functionality and security of your account. Please accept cookies to continue with the login process."
  //       onClick={handleAcceptFromModal}
  //       okButtonText="Accept Cookies"
  //       cancelButtonText="Cancel"
  //       cancelFunction={handleCloseLoginBlocked}
  //       type="warning"
  //     />
  //   </>
  // );
};

// Export function to show login blocked modal (commented out - no longer needed)
// export const showLoginBlockedModalFn = () => {
//   if (showLoginBlockedModalRef) {
//     showLoginBlockedModalRef();
//   }
// };

export default CookieConsent;
